const files = [
  'admins',
  'auth',
  'groups',
  'images',
  'kontrollers',
  'orders',
  'points',
  'problems',
  'programs',
  'promocodes',
  'questions',
  'tickets',
  'users',
  'bonuses',
  'dealers',
  'config',
  'events',
  'purchases'
]
let index = {}

files.forEach(file => {
  index[file] = require(`./${file}`).default
})

export default index
